import type { ReactNode } from "react"
import { Alert, AlertDescription } from "@/components/ui/alert"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"
import { AlertCircle, GalleryVerticalEnd, Info } from "lucide-react"

interface Props {
  title: string
  subtitle: string
  alert?: string | null
  notice?: string | null
  children: ReactNode
}

export default function AuthLayout({ title, subtitle, alert, notice, children }: Props) {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <a href="/" className="flex items-center gap-2 self-center font-medium">
          <div className="flex size-6 items-center justify-center rounded-md bg-primary text-primary-foreground">
            <GalleryVerticalEnd className="size-4" />
          </div>
          FEPI
        </a>

        <div className="flex flex-col gap-6">
          <Card>
            <CardHeader className="text-center">
              <CardTitle className="text-xl">{title}</CardTitle>
              <CardDescription>{subtitle}</CardDescription>
            </CardHeader>
            <CardContent>
              <div className="flex flex-col gap-6">
                {alert && (
                  <Alert variant="destructive">
                    <AlertCircle className="size-4" />
                    <AlertDescription>{alert}</AlertDescription>
                  </Alert>
                )}

                {notice && (
                  <Alert>
                    <Info className="size-4" />
                    <AlertDescription>{notice}</AlertDescription>
                  </Alert>
                )}

                {children}
              </div>
            </CardContent>
          </Card>

          <div className="text-muted-foreground px-6 text-center text-xs text-balance [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-primary">
            Al continuar, aceptas nuestros <a href="#">Términos de servicio</a>{" "}
            y <a href="#">Política de privacidad</a>.
          </div>
        </div>
      </div>
    </div>
  )
}
